export const AccountTransactionTypeInvoice = "invoice"
export const AccountTransactionTypeCreditMemo = "credit-memo"


// WEBPACK FOOTER //
// ./src/state/contact/AccountTransactionsType.ts